import type { NetworkType } from "Data/Objects/Network";

export const ENCRYPTIONS = [
	"HTTP",
	"HTTPS",
	"HTTP & HTTPS"
] as const satisfies ReadonlyArray<string>;

export type EncryptionType = (typeof ENCRYPTIONS)[ number ];

export enum RtspAuthenticationType {
	OFF = "OFF",
	BASIC = "BASIC",
	DIGEST = "DIGEST"
}

export enum HttpAuthenticationType {
	BASIC = "BASIC",
	DIGEST = "DIGEST"
}

export enum IpFilterRule {
	ALLOW = "ALLOW",
	BLOCK = "BLOCK"
}

export enum IpFilterType {
	SINGLE_ADDRESS = "SINGLE ADDRESS",
	ADDRESS_RANGE = "ADDRESS RANGE"
}

export enum EapType {
	TLS = "EAP-TLS",
	MD5 = "EAP-MD5"
}

export enum CertificateType {
	CA = "CA Certificate",
	CLIENT = "Client Certificate",
	KEY = "Client Key",
	SSL = "Certificate",
	DCV_HTTP = "DCV (HTTP)"
}

export type IpFilter = {
	type: IpFilterType;
	addresses: string[];
};

export type SecurityCertificate = {
	type: CertificateType;
	name: string;
	issuer?: string;
	subject?: string;
	validStart?: Date;
	validEnd?: Date;
};

export type NetworkSecuritySettings = {
	rtspAuthType: RtspAuthenticationType;
	encryptionType: EncryptionType;
	httpAuthType: HttpAuthenticationType;
};

export type IpFilteringOptions = {
	ipFilterEnabled: boolean;
	ipFilterRule: IpFilterRule;
};

export type SetupIeee802Options = {
	enabled: boolean;
	eapType: EapType;
	eapolVersion: number;
	id: string;
	password: string;
	clientKeyPassword: string;
};

export type IpFilteringSettings = {
	filters: IpFilter[];
} & IpFilteringOptions;

export type NetworkIpv4Settings = {
	ipv4NetworkType: NetworkType;
	ipv4Address: string;
	subnetMask: string;
	ipv4Gateway: string;
	dnsIpv4: string[];
};

export type NetworkIpv6Settings = {
	ipv6NetworkType: NetworkType;
	linkLocalAddress: string;
	ipv6Address: string;
	prefixLength: number;
	ipv6Gateway: string;
	dnsIpv6: string[];
};

export type ServicePortSettings = {
	httpPort: number;
	rtspPort: number;
	httpsPort: number;
};

export type NetworkIpSettings = {
	ipv4Settings: NetworkIpv4Settings;
	ipv6Settings: NetworkIpv6Settings;
	servicePortSettings: ServicePortSettings;
};
